export const EMPLOYEE = {
  GET_EMPLOYEE: 'GET_EMPLOYEE',
  GET_EMPLOYEE_SUCCESS: 'GET_EMPLOYEE_SUCCESS',
  GET_EMPLOYEE_FAIL: 'GET_EMPLOYEE_FAIL',

  GET_COMPANY_EMPLOYEE_LIST: 'GET_COMPANY_EMPLOYEE_LIST',
  GET_COMPANY_EMPLOYEE_LIST_SUCCESS: 'GET_COMPANY_EMPLOYEE_LIST_SUCCESS',
  GET_COMPANY_EMPLOYEE_LIST_FAIL: 'GET_COMPANY_EMPLOYEE_LIST_FAIL',

  GET_COMPANY_EMPLOYEE_ADDING: 'GET_COMPANY_EMPLOYEE_ADDING',
  GET_COMPANY_EMPLOYEE_ADDING_SUCCESS: 'GET_COMPANY_EMPLOYEE_ADDING_SUCCESS',
  GET_COMPANY_EMPLOYEE_ADDING_FAIL: 'GET_COMPANY_EMPLOYEE_ADDING_FAIL',

  GET_COMPANY_EMPLOYEE_INNER: 'GET_COMPANY_EMPLOYEE_INNER',
  GET_COMPANY_EMPLOYEE_INNER_SUCCESS: 'GET_COMPANY_EMPLOYEE_INNER_SUCCESS',
  GET_COMPANY_EMPLOYEE_INNER_FAIL: 'GET_COMPANY_EMPLOYEE_INNER_FAIL',

  GET_COMPANY_EMPLOYEE_POPUP: 'GET_COMPANY_EMPLOYEE_POPUP',
  GET_COMPANY_EMPLOYEE_POPUP_SUCCESS: 'GET_COMPANY_EMPLOYEE_POPUP_SUCCESS',
  GET_COMPANY_EMPLOYEE_POPUP_FAIL: 'GET_COMPANY_EMPLOYEE_POPUP_FAIL',

  GET_EMPLOYEE_FOR_REVIEW: 'GET_EMPLOYEE_FOR_REVIEW',
  GET_EMPLOYEE_FOR_REVIEW_SUCCESS: 'GET_EMPLOYEE_FOR_REVIEW_SUCCESS',
  GET_EMPLOYEE_FOR_REVIEW_FAIL: 'GET_EMPLOYEE_FOR_REVIEW_FAIL',

  POST_EMPLOYEE_REVIEW: 'POST_EMPLOYEE_REVIEW',

  POST_COMPANY_EMPLOYEE_CREATE: 'POST_COMPANY_EMPLOYEE_CREATE',
  PATCH_COMPANY_EMPLOYEE_FIRE: 'PATCH_COMPANY_EMPLOYEE_FIRE',
  PATCH_COMPANY_EMPLOYEE_RETURN: 'PATCH_COMPANY_EMPLOYEE_RETURN',

  PATCH_COMPANY_EMPLOYEE_INNER: 'PATCH_COMPANY_EMPLOYEE_INNER',
  POST_COMPANY_EMPLOYEE_INNER: 'POST_COMPANY_EMPLOYEE_INNER',

  CLEAR_EMPLOYEE: 'CLEAR_EMPLOYEE',

  GET_EMPLOYEE_LIST_ADDING: 'GET_EMPLOYEE_LIST_ADDING',
  GET_EMPLOYEE_LIST_ADDING_SUCCESS: 'GET_EMPLOYEE_LIST_ADDING_SUCCESS',
  GET_EMPLOYEE_LIST_ADDING_FAIL: 'GET_EMPLOYEE_LIST_ADDING_FAIL',


  POST_EMPLOYEE_ADD_PROJECTS: 'POST_EMPLOYEE_ADD_PROJECTS',

};
